import React from 'react';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation('notfound'); // Usando o namespace 'notfound'

    return (
        <div className="notfound-container">
            <h2>{t('title')}</h2>
            <p>{t('description')}</p>
        </div>
    );
};

export default NotFound;
